
// #721 round 2 follow-up: what the resolver knows about the client's CURRENT
// plans for the shopping year, for advisors browsing /plans or a plan's
// details. Client-facing wording for these two cases is Dien's (spec D24),
// so this stays agent-only.
import { mapGetters } from 'vuex'
import { planOnFile } from '~/util/summary-plans'

const LABEL = { supp: 'supplement', pdp: 'drug plan', mapd: 'Medicare Advantage plan' }

export default {
    computed: {
        ...mapGetters(['canAgent', 'aepCurrentResolved', 'survey']),
        notices () {
            const r = this.aepCurrentResolved
            if (!r || !r.lines) { return [] }
            return Object.keys(LABEL).map((kind) => {
                const line = r.lines[kind]
                const name = planOnFile(this.survey, kind) || `${LABEL[kind]} on file`
                if (line?.status === 'terminated') {
                    return { kind, text: `The client's current ${LABEL[kind]}, ${name}, is not offered in ${r.year}.` }
                }
                if (line?.status === 'consolidated') {
                    return { kind, text: `The client's current ${LABEL[kind]}, ${name}, is being merged into ${line.resolved_name} for ${r.year}.` }
                }
                return null
            }).filter(Boolean)
        },
    },
}
